/* eslint-disable */
// REACT STUFF
import {
  React,
  useState,
  useContext,
  useEffect
} from 'react';
import { useRoutes, Navigate, Route } from 'react-router-dom';
// STYLING STUFF
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ThemeProvider } from '@mui/material';
import GlobalStyles from 'src/components/GlobalStyles';
import theme from 'src/theme';
// PAGES & COMPONENTS
import Dashboard from 'src/pages/Dashboard';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';



import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
// UTILS

import { prepNewData } from 'src/utils/dataProcessing';
import { UserContext } from './providers/UserProvider';

// URL FOR Data 
import {token_url, username, password} from 'src/utils/constants';
import {sites_url} from 'src/utils/constants';

const getSites = async (token) => {
   return await fetch(sites_url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token
    }
  }).then((response) => {
    if (response.ok){ 
      return response.json();
    }else{
      console.log(response)
    }
    throw response;
  }).catch((err) => {
    console.error(err);
  });
};


const App = () => {
  const [token, setToken] = useState();
  const [latestReading, setlatestReading] = useState({});

  let storedSited = JSON.parse(localStorage.getItem("sites")) 
  if( !storedSited ){
    storedSited =[];
  }
  const [ sites, setSites]  = useState(storedSited);

  // try to get authenticated user
  const {user, setUser} = useContext(UserContext);

  function fillOutSite (site){
    site['href'] = '/dashboard/'+site.site_id;
    site['title'] = site.site_name;
  }

  useEffect(() => {
      if (user != null){
          setToken(user['apiToken']);
      }
  }, [user]);

  useEffect(() => {
    if( token != null){ 
      getSites(user['apiToken']).then((returnedSites)=> {  
      returnedSites.forEach(fillOutSite);
      setSites(returnedSites);
      localStorage.setItem("sites", JSON.stringify(returnedSites)) 
    });
    }
    
  }, [token]);

  // If not signed in, all routes lead to login page except register
  const routesForSignedOut = [
    {
      path: '*',
      element: <Login />
    }
  ];

  const routes = [
    {
      path: 'dashboard',
      element: <DashboardLayout sites={sites} authUser={user} />,
      children: [
        { path: ':siteId', element: <Dashboard latest={latestReading} token={token}/> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/',
      element:  <MainLayout sites={sites} />,
      children: [
        { path: 'login', element: <Login /> },
        //{ path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="dashboard/1" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ];
  // Set routing based on signed in status
  let routing = null;
  if (user !== undefined && user !== null){
    if (Object.keys(user).length > 0) {
      if (user.role === 'ADMIN') {
        routes[0].children.push({ path: 'controlPanel', element: <ControlPanel /> });
      }
      routing = useRoutes(routes);
    }else {
      routing = useRoutes(routesForSignedOut);
    }
  } else {
      routing = useRoutes(routesForSignedOut);
  }
  // Render App
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
    </ThemeProvider>
  );
};
export default App;
